import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";

const contratosAdapter = createEntityAdapter({
  // Assume IDs are stored in a field other than `book.id`
  selectId: (x) => x.contratoId,

  // Keep the "all IDs" array sorted based on book titles
  // sortComparer: (a, b) => a.title.localeCompare(b.title),
})

const initialState = contratosAdapter.getInitialState();

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getContratos: builder.query({
      query: () => 'contratos',
      transformResponse: responseData => {
        return contratosAdapter.setAll(initialState, responseData)
      },
      providesTags: (result, error, arg) => [
        { type: 'Contratos', id: 'LIST' },
        ...(result?.ids || []).map(id => ({ type: 'Contratos', id }))
      ]
    }),
    crearContratos: builder.mutation({
      query: (newContrato) => (
        {
          url: 'contratos',
          method: 'post',
          body: newContrato
        }),
      invalidatesTags: ["Contratos", "Personas", "PersonasRolesMap", "TitularidadContratos", "Campanas", "CDC_TitularidadContratos"],
    }),
    clasesContratos: builder.query({
      query: ()=> 'clasesContrato',
      providesTags: (result, error, arg)=>[
        {type:'ClasesContratos', id: 'LIST'}
      ]
    }),
    getContratosById: builder.query({
      query: (id) => 'infocontrato/' + id,

    }),
    getContratosCdc: builder.query({
      query: () => 'contratos-cdc',
      providesTags: (result, error, arg)=>[
        {type:'CDC_TitularidadContratos', id: 'LIST'}]
    }),
    editContratos: builder.mutation({
      query: (newContrato) => (
        {
          url: 'contratos',
          method: 'put',
          body: newContrato
        }),
      invalidatesTags: ["Contratos", "Personas", "PersonasRolesMap", "TitularidadContratos", "Campanas",  "CDC_TitularidadContratos", "CDC_Contratos"],
    }),
    crearCuponesMensuales: builder.mutation({
      query: (cupones) => (
        {
          url: 'cupones-mensuales',
          method: 'post',
          body: cupones
        }),
      invalidatesTags: ["Contratos", "RegistrosMail", "Cupones", "BatchEnviosMails"],
    }),
    deleteContratos: builder.mutation({
      query: (contratos) => (
        {
          url: 'contratos',
          method: 'delete',
          body: contratos
        }),
      invalidatesTags: ["Contratos", "Personas", "PersonasRolesMap", "TitularidadContratos", "Campanas",  "CDC_TitularidadContratos", "CDC_Contratos"],
    }),
  })
});

export const { useGetContratosQuery,  useGetContratosCdcQuery, useGetContratosByIdQuery, useEditContratosMutation, useClasesContratosQuery, useCrearContratosMutation, useCrearCuponesMensualesMutation, useDeleteContratosMutation } = extendedApiSlice;

//A: returns the query result object
export const selectContratosResult = extendedApiSlice.endpoints.getContratos.select();

//A: created memoized selector
const selectContratosData = createSelector(
  selectContratosResult,
  contratosResult => contratosResult.data  //A: normalized state object with ids and entities
);

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
  selectAll: selectAllContratos,
  selectById: selectContratoById,
  selectIds: selectContratosIds
} = contratosAdapter.getSelectors(state => selectContratosData(state) ?? initialState);

//A:selector for get all contratos by idsList
const selectContratosIdsList = (state, contratosIds) => contratosIds

export const selectContratosByIds = createSelector(
  [selectAllContratos, selectContratosIdsList],
  (contratos, contratosIds) => contratos.filter(contrato => contratosIds.includes(contrato.contratoId))
)